import React from "react";
import { Modal, Button, Col } from "react-bootstrap";
import moment from "moment";

const ViewPromoCodeModal = ({ modalOpen, setModalOpen, promoCode, title }) => {
  const hideHandler = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      show={modalOpen}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col lg="12">
          <div className="mb-3">
            <strong>Code: </strong>
            <span>{promoCode?.code || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Discount Value: </strong>
            <span>{promoCode?.discountValue || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Limit: </strong>
            <span>{promoCode?.limit || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Limit Per User: </strong>
            <span>{promoCode?.limitPerUser || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Promo Code Type: </strong>
            <span>{promoCode?.promoCodeType || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Discount Type: </strong>
            <span>{promoCode?.discountType || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Promo For: </strong>
            <span>
              {promoCode?.promoFor === "onlineStore"
                ? "Online Store - Product Specific"
                : promoCode?.promoFor === "mealPlan"
                ? "Meal Plan"
                : promoCode?.promoFor === "both"
                ? "Online Store + Meal Plan"
                : "-"}
            </span>
          </div>

          {promoCode?.promoFor === "onlineStore" &&
            promoCode?.selectedProducts && (
              <div className="mb-3">
                <strong>Selected Products: </strong>
                <span>
                  {promoCode.selectedProducts.length > 0
                    ? promoCode.selectedProducts.join(", ")
                    : "-"}
                </span>
              </div>
            )}

          <div className="mb-3">
            <strong>Description: </strong>
            <span>{promoCode?.description || "-"}</span>
          </div>

          <div className="mb-3">
            <strong>Start Date: </strong>
            <span>
              {promoCode?.startDate
                ? moment(promoCode.startDate).format("DD/MM/YYYY")
                : "-"}
            </span>
          </div>

          <div className="mb-3">
            <strong>Expire Date: </strong>
            <span>
              {promoCode?.expireDate
                ? moment(promoCode.expireDate).format("DD/MM/YYYY")
                : "-"}
            </span>
          </div>

          <div className="mb-3">
            <strong>Status: </strong>
            <span>{promoCode?.status || "-"}</span>
          </div>
        </Col>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={hideHandler}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewPromoCodeModal;
